import { render, staticRenderFns } from "./download.vue?vue&type=template&id=83515290&"
import script from "./download.vue?vue&type=script&lang=js&"
export * from "./download.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83515290')) {
      api.createRecord('83515290', component.options)
    } else {
      api.reload('83515290', component.options)
    }
    module.hot.accept("./download.vue?vue&type=template&id=83515290&", function () {
      api.rerender('83515290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/download.vue"
export default component.exports